/**
 * Client-side only authentication hook
 * Prevents hydration mismatches and cookie access issues
 */

'use client';

import { useEffect, useState } from 'react';

export function useClientSideAuth() {
  const [isClient, setIsClient] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Mark as client-side after hydration
    setIsClient(true);
    
    // Small delay to ensure cookies are fully available
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return {
    isClient,
    isInitialized,
    // Only allow auth operations after client-side initialization
    canAccessAuth: isClient && isInitialized
  };
}
